export const CarClassStatus = {
	soldOut: "Soldout",
	onRequest: "OnRequest",
	available: "Available",
	invisible: "Invisible",
};
